module.exports = __webpack_public_path__ + "static/media/Client14Millenium.82d5585b.png";